import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './incubacaoMaturidadeAno2Form';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';

import { setModoTela, initForm, salvar, excluir, getLista } from './incubacaoMaturidadeAno2Actions';
import { setModoTela as setModoTelaIncubacao } from '../incubacao/incubacaoActions';
import ContentCardFooter from '../common/template/contentCardFooter';
import Background from '../common/template/background';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';
import TextoInput from '../texto/textoInput';
import { getLista as getListaVideo } from '../video/videoActions';
import consts from '../consts';

class IncubacaoMaturidadeAno2 extends Component {

	state = {
		linhaSelecionada: null
	}

	componentDidMount() {

	}

    componentWillMount() {
        this.props.getLista();
		this.props.getListaVideo();
    }

    render() {
        return (
            <Background>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'visualizacao' ? (
						<Form visualizacao onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </Background>
        )
    }

	lista() {

		let lista = this.props.lista.filter(item => item.id_incubacao == this.props.incubacao.id);
		
		return (
			<>
				<Row alignCenter style={{ marginTop: 80, marginBottom: 80 }}>
					<Grid cols='10 6 4 3'>
						<p style={{ textAlign: 'center', color: '#ffffff', margin: 0, padding: 0 }}>{this.props.incubacaoMaturidadeAno2Titulo}</p>

						<TextoInput chave='incubacaoMaturidadeAno2Titulo' />
					</Grid>
				</Row>

				<Row alignCenter >
					{this.props.listaVideo.map(item => (							
						<Grid key={item.id} cols='12 12 8 4'
							style={{ 
								padding: 8, 
								margin: 8, 
								backgroundColor: 'rgba(15, 39, 72, 0.8)',
								borderRadius: 10, 
								boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)', 
								display: 'flex',
								flexDirection: 'column',
								justifyContent: 'space-between'
							}}>
							<div>
								<label style={{ padding: 2, margin: 0, fontSize: 18, color: '#ffffff' }}>{item.nome}</label>
								<p style={{ padding: 2, margin: 0, fontSize: 14, color: '#ffffff' }}><b>Professor(a): </b>{item.professor}</p>
								<p style={{ padding: 2, margin: 0, fontSize: 14, color: '#ffffff' }}><b>Conteúdo: </b></p>
								{(item.conteudo || '').split('\n').map(linha => (
									<p style={{ padding: 0, margin: 0, marginLeft: 4, fontSize: 14, color: '#ffffff' }}>{linha}</p>
								))}
							</div>						
							<div style={{ position: 'relative', width: '100%', aspectRatio: '16 / 9', marginTop: 12 }}>
								<iframe
									width="100%"
									height="100%"
									src={item.link}
									allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
									allowFullScreen></iframe>
							</div>
						</Grid>					
					))}
				</Row>

				{lista.map(item => (
					<Row alignCenter>
						<Grid cols='12 10 8 6'>
							<ContentCard
								style={{
									marginTop: 20,
									backgroundColor: '#0F2748',
									color: '#ffffff',
									borderRadius: 20,
									boxShadow: '0px 0px 10px rgba(255, 255, 255, 0.9)',
									opacity: '80%'
								}}>
								<ContentCardBody>
									<Row alignCenter 
										style={{ 
											padding: 16
										}}>
										<Grid cols='12 12 12 12'>
											<p style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 18 }}>Indicador de Maturidade</p>
										</Grid>
										<Grid cols='12 12 12 12'>
											<p style={{ textAlign: 'center', fontWeight: 'bold', fontSize: 18 }}>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_inclusao)}</p>
										</Grid>
										<Grid cols='12 10 6 4'>
											<Button
												text='Visualizar / Editar'
												type={'primary'}
												icon={'fa fa-plus'}
												event={() => {
													this.props.setModoTela('cadastro', {
														...item,
														financeiro_cac: FormatUtils.formatarValorTela(item.financeiro_cac, 2),
														financeiro_faturamento: FormatUtils.formatarValorTela(item.financeiro_faturamento, 2),
														financeiro_custo_fixo: FormatUtils.formatarValorTela(item.financeiro_custo_fixo, 2),
														financeiro_custo_variavel: FormatUtils.formatarValorTela(item.financeiro_custo_variavel, 2),
														financeiro_lucro: FormatUtils.formatarValorTela(item.financeiro_lucro, 2),
														financeiro_investimento: FormatUtils.formatarValorTela(item.financeiro_investimento, 2),
														mercado_propspects: FormatUtils.formatarValorTela(item.mercado_propspects, 0),
														mercado_clientes: FormatUtils.formatarValorTela(item.mercado_clientes, 0),
														mercado_satisfacao: FormatUtils.formatarValorTela(item.mercado_satisfacao, 2),
														mercado_recorrencia: FormatUtils.formatarValorTela(item.mercado_recorrencia, 2),
														gestao_metas: FormatUtils.formatarValorTela(item.gestao_metas, 2),
														inovacao_editais: FormatUtils.formatarValorTela(item.inovacao_editais, 2),
														pessoas_colaboradores: FormatUtils.formatarValorTela(item.pessoas_colaboradores, 0),
														pessoas_dedicacao: FormatUtils.formatarValorTela(item.pessoas_dedicacao, 0),
														pessoas_horas: FormatUtils.formatarValorTela(item.pessoas_horas, 0)
													});
													this.props.initForm({
														...item,
														financeiro_cac: FormatUtils.formatarValorTela(item.financeiro_cac, 2),
														financeiro_faturamento: FormatUtils.formatarValorTela(item.financeiro_faturamento, 2),
														financeiro_custo_fixo: FormatUtils.formatarValorTela(item.financeiro_custo_fixo, 2),
														financeiro_custo_variavel: FormatUtils.formatarValorTela(item.financeiro_custo_variavel, 2),
														financeiro_lucro: FormatUtils.formatarValorTela(item.financeiro_lucro, 2),
														financeiro_investimento: FormatUtils.formatarValorTela(item.financeiro_investimento, 2),
														mercado_propspects: FormatUtils.formatarValorTela(item.mercado_propspects, 0),
														mercado_clientes: FormatUtils.formatarValorTela(item.mercado_clientes, 0),
														mercado_satisfacao: FormatUtils.formatarValorTela(item.mercado_satisfacao, 2),
														mercado_recorrencia: FormatUtils.formatarValorTela(item.mercado_recorrencia, 2),
														gestao_metas: FormatUtils.formatarValorTela(item.gestao_metas, 2),
														inovacao_editais: FormatUtils.formatarValorTela(item.inovacao_editais, 2),
														pessoas_colaboradores: FormatUtils.formatarValorTela(item.pessoas_colaboradores, 0),
														pessoas_dedicacao: FormatUtils.formatarValorTela(item.pessoas_dedicacao, 0),
														pessoas_horas: FormatUtils.formatarValorTela(item.pessoas_horas, 0)
													});
												}} />
										</Grid>
									</Row>
								</ContentCardBody>
							</ContentCard>
						</Grid>
					</Row>
				))}

				<Row alignCenter>
					<Grid cols='12 12 10 8'>
						{(!lista[0] || this.props.sessao.id == lista[0].id_usuario || (lista[0].id_empreendedores || []).includes(this.props.sessao.id)) &&	
						<Row alignCenter style={{ padding: 8, marginTop: 30 }}>
							<Grid cols='10 8 6 4'>
								<button 
									type='button'
									class='btn btn-trilha btn-block btn-flat'
									onClick={() => {
										this.props.setModoTela('cadastro', {});
										this.props.initForm({ id_incubacao: this.props.incubacao.id });
									}}>
									Adicionar Indicador de Maturidade
								</button>
							</Grid>
						</Row>}						
						<Row alignCenter style={{ padding: 8, marginTop: 30 }}>
							<Grid cols='10 8 6 4'>
								<button 
									type='button'
									class='btn btn-trilha btn-block btn-flat'
									onClick={() => {
										this.props.setModoTela('lista', {});
										this.props.setModoTelaIncubacao('trilha');
										this.props.initForm({});
										window.scrollTo(0, 0);
									}}>
									Voltar para Trilha
								</button>
							</Grid>
						</Row>
					</Grid>
				</Row>
			</>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.incubacaoMaturidadeAno2.modoTela,
	aguardando: state.incubacaoMaturidadeAno2.aguardando,
	lista: state.incubacaoMaturidadeAno2.lista.filter(item => state.auth.usuario.administrador || item.id_usuario == state.auth.usuario.id || (item.id_empreendedores || []).includes(state.auth.usuario.id)),
	incubacaoMaturidadeAno2Titulo: state.texto.lista.filter(item => item.chave == 'incubacaoMaturidadeAno2Titulo').map(item => item.valor)[0],
	listaVideo: state.video.lista.filter(item => item.trilha == 'incubacao_maturidade_ano2')
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, initForm, salvar, excluir, getLista, setModoTelaIncubacao, getListaVideo
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(IncubacaoMaturidadeAno2);
